import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";
import styled, { css } from "styled-components";

export const TopologyContainer = styled.div<{
  $overrideAspectRatio?: string;
  $overrideMobileAspectRatio?: string;
}>`
  display: flex;
  justify-content: center;
  position: relative;
  aspect-ratio: 1384/974;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    aspect-ratio: 964/764;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    aspect-ratio: ${({ $overrideMobileAspectRatio }) =>
      $overrideMobileAspectRatio ?? "432/1200"};
  }

  ${({ $overrideAspectRatio }) =>
    $overrideAspectRatio &&
    css`
      aspect-ratio: ${$overrideAspectRatio};
    `}
`;

export const TopologyInViewContainer = styled.div`
  height: 100%;
  width: 100%;
`;

export const ColumnContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  z-index: 2;
`;

export const RowContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 124px;
  justify-content: center;
  width: 100%;
`;
